import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`delete/attachment/${id}`)
}
